import { render } from "./MFAView.vue?vue&type=template&id=e6879496&ts=true"
import script from "./MFAView.vue?vue&type=script&lang=ts"
export * from "./MFAView.vue?vue&type=script&lang=ts"

import "./MFAView.vue?vue&type=style&index=0&id=e6879496&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__